// extracted by mini-css-extract-plugin
export default {"downloadClient":"DownloadClient-downloadClient-wZ1JM Card-card-aoesq","name":"DownloadClient-name-eDUtm","enabled":"DownloadClient-enabled-SSDPC"};